<template>

<div class="row justify-content-center">

    <div class='col-md-10' v-if='isReady && !projects.length'>
        <div class="alert alert-info">
            <div>
                Все още не сте участвали в проекти. <br>
                Можете да разгледате <a href='/active-projects'>активни проекти от тук</a> и да кандидатствате за изпълнението им.
            </div>
        </div>
    </div>

    <div v-for='p in projects' class="col-md-10">
        <div class="container user-project">
            <div class="row">
                <div class="col-12 col-md-5 col-lg-4 p-0 user-project-img">
                    <a :href="'/projects/' + p.id + '/record'"">
                        <img :src="p.image ? p.image : '/resources/images/def-img.jpg'" alt="User project picture">
                    </a>
                </div>
                <div class="col-12 col-md-7 col-lg-8">
                    <div class="row user-project-params">
                        <div class="project-date col-6 col-sm-4 d-flex align-items-center justify-content-center">
                            <span class="icon icon-calendar-start mr-2"></span>
                            <span>
                                <span class="param-label">Старт:</span>
                                <span class="param-val"> {{ dateOnly( p.created_at ) }}</span>
                            </span>
                        </div>
                        <div class="project-date col-6 col-sm-4 d-flex align-items-center justify-content-center">
                            <span class="icon icon-calendar-end mr-2"></span>
                            <span>
                                <span class="param-label">Край:</span>
                                <span class="param-val">
                                    <span v-if='p.finished == 1'>{{ dateOnly( p.finished_at ) }}</span>
                                    <span v-if='p.finished == 0'>-</span>
                                </span>
                            </span>
                        </div>
                        <div class="project-type col-12 col-sm-4">
                            <span class="d-sm-block pr-3 pr-sm-0">
                                <span class="icon icon-flag mr-2"></span>
                                <span class="">{{ p.city }}</span>
                            </span>
                            <span class="d-sm-block">
                                <span class="icon icon-folder mr-2"></span>
                                <span class=""> {{ p.type }} </span>
                            </span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 user-project-name">
                            <h3> {{ p.name }} </h3>
                            <p class="user-project-status">
                                <span>
                                    <span class="icon icon-check"></span>
                                    Кандидатствали сте за:
                                </span>
                                <span class="status-val"> 
                                    {{ p.phase }}
                                </span> 
                            </p>
                            <p v-if='p.winner_id == user.id' class="user-project-status">
                                <span>
                                    <span class="icon icon-check"></span>
                                    Вие сте победител в тази фаза
                                </span>
                            </p>
                            <p class="user-project-status">
                                <span>
                                    <span class="icon icon-check"></span>
                                    Статус на проекта : 
                                </span>
                                <span class="status-val"> 
                                    {{ p.finished == 0 ? "В процес" : "Завършил проект" }}   
                                </span> 
                            </p>
                            <p class="user-project-status">
                                <span>
                                    <span class="icon icon-check"></span>
                                    Статус на фазата : 
                                </span>
                                <span class="status-val"> 
                                    {{ p.pp_staus == 0 ? "В процес" : "Завършила" }}   
                                </span> 
                            </p>
                        </div>
                    </div>
                    <div class="row user-project-buttons">
                        <div class="col-12 ">
                            <a :href="'/projects/' + p.id + '/record'" class='btn btn-primary mr-0 mr-sm-2'>
                                <span class="icon icon-activity"></span>
                                Досие на проекта
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

</template>

<script>
    export default {

        mounted() {
            
            this.getData();

        },

        created() {
            this.setBcLinks([ { name : 'Участия в проекти', url : 'part-projects' } ]);
        },

        data() {
            return {
                
                isReady         : false,
                projects        : [],
                currentProject  : false,
                winnerProject   : false,

            }
        },

        methods : {

            getData() {
                var me = this;

                me.ajax.call("prj:gwp", {}, (r) => {

                    if( r.status == 'success' ) {
                        
                        me.projects = r.data;
                        me.isReady  = true;

                    }

                })
            }

        }

    }
</script>
